import {createFileRoute} from '@tanstack/react-router';

import {SettingsLandingPage} from '@/modules/settings/pages/SettingsLandingPage';

export const Route = createFileRoute('/_authenticated/account/')({
  component: SettingsLandingPage,
});
